import { action, computed, observable } from 'mobx';

import { Paginated } from '../adl-gen/common';
import { DbKey } from '../adl-gen/common/db';
import { AppUser } from '../adl-gen/totalinteraction/futurefit/db';
import { QuizReportSummary } from '../adl-gen/totalinteraction/futurefit/requests';
import { fromPromise, MaybeLoading } from '../loader/loader';
import { Service } from '../service/service';

import { LoggedIn } from './identity-store';

export class ManagerPortalStore {
  @observable quizReportSummaries: Promise<Paginated<QuizReportSummary>>;

  constructor(private readonly service: Service, private readonly identity: LoggedIn) {
    const appUserId = this.identity.appUserWithDbId.id;
    this.quizReportSummaries = this.loadAll(appUserId);
  }

  @computed
  get loading(): MaybeLoading<Paginated<QuizReportSummary>> {
    return fromPromise(this.quizReportSummaries);
  }

  @action
  setThingsToLoad = (promise: Promise<Paginated<QuizReportSummary>>): void => {
    this.quizReportSummaries = promise;
  };

  loadAll = async (appUserId: DbKey<AppUser>): Promise<Paginated<QuizReportSummary>> => {
    const quizReportSummaries = await this.service.queryQuizReports(appUserId);
    return quizReportSummaries;
  };
}



// WEBPACK FOOTER //
// ./src/stores/manager-portal-store.ts